var map = {
	"./Handshake_1.svg": 4586,
	"./addFile.svg": 9558,
	"./approve.svg": 6995,
	"./archi.png": 7669,
	"./arrow.svg": 8813,
	"./autres.png": 6199,
	"./bina-logo.webp": 5630,
	"./check.webp": 3424,
	"./choose.webp": 563,
	"./close.webp": 1731,
	"./colab.svg": 1803,
	"./collaboration.svg": 8323,
	"./contact.webp": 106,
	"./contrat.png": 444,
	"./corp1.svg": 6412,
	"./corp2.svg": 6682,
	"./corp3.svg": 7944,
	"./corp4.svg": 3109,
	"./corps_detat.png": 2230,
	"./crossair.svg": 3393,
	"./delai.png": 1667,
	"./delay.svg": 8029,
	"./eco.png": 5429,
	"./etude.png": 3012,
	"./facebook.svg": 3536,
	"./file.webp": 1320,
	"./handleshake.svg": 7025,
	"./header.webp": 4462,
	"./improvement.svg": 7645,
	"./infoClient.webp": 6105,
	"./instagram.svg": 5397,
	"./interlocuteur.png": 5212,
	"./key.svg": 5582,
	"./key2.svg": 7683,
	"./lecture.png": 6597,
	"./letter.webp": 2961,
	"./like.svg": 2411,
	"./linkedin.svg": 7657,
	"./menu.webp": 1950,
	"./phone.webp": 5758,
	"./pinterest.svg": 7698,
	"./prix.png": 7306,
	"./pro.png": 6997,
	"./profil1.png": 4968,
	"./profil2.png": 4806,
	"./residentiel.png": 1081,
	"./retail.png": 5198,
	"./service.webp": 9581,
	"./sheild.svg": 5810,
	"./surface.webp": 6091,
	"./travaux.png": 2239,
	"./user.webp": 3776
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;